export const DOC_FLOW_SENDING_RESULT_PERMANENT_NOTIFICATION_ID =
  'docFlowSendingResultPermanentNotification'

export const DOC_FLOW_SENDING_RESULT_SUCCESS_NOTIFICATION_ID =
  'docFlowSendingResultSuccessNotification'

export const DOC_FLOW_SENDING_RESULT_ERROR_NOTIFICATION_ID =
  'docFlowSendingResultErrorNotification'
